import React from 'react';
import '../Styles/ThankYou.css';
//import { DotLottieReact } from '@lottiefiles/dotlottie-react'; // Temporarily hide Lottie

function ThankYou() {
  return (
    <div className="thankyou-container">
      <div className="thankyou-header">
        {/* Removed thumbs up icon */}
        <h1>
          Certification Submission Received!
        </h1>
      </div>
      {/* Temporarily hide Lottie animation */}
      {/* <div className="confetti-overlap">
        <DotLottieReact
          src="https://lottie.host/116624a4-53aa-4ec1-9565-6b7bb063c42e/Xqn0oIQhVF.lottie"
          loop
          autoplay
          style={{ width: 600, height: 400 }}
        />
      </div> */}
      <div className="thankyou-content">
        <div className="thankyou-paras">
          <p>Thank you for taking the first step towards becoming certified with Outstanding Workplaces!</p><br />
          <p>We're thrilled to have you on board and look forward to working together to elevate workplace excellence.</p><br />
          <p>Our team will review your submission and details.</p><br />
          <p>You'll receive an email from us at the address you provided in the registration form with further instructions.</p><br />
          <p>We'll guide you through the next steps to achieve Outstanding Workplaces certification.</p>
        </div>
        {/* <h3>Welcome to the Journey!</h3> */}
        <div className="thankyou-paras">
          {/* <p>We're excited to have you as part of our community committed to creating exceptional workplaces.</p> */}
          <p>Thank you for choosing Outstanding Workplaces!</p>
          <p>
            Stay tuned for updates, and don't hesitate to reach out if you have any questions :<br />
            <a href="mailto:support@outstandingworkplaces.co">support@outstandingworkplaces.co</a> / <a href="tel:9751529398">9751529398.</a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default ThankYou;